import { useRouteState } from './routeHooks';

const RouteUpdater = () => {
    useRouteState(() => {});
    return null;
};

export default RouteUpdater;
